import { reportError } from "@/lib/error-reporting/report-error";

// 録音データが空だったときの案内。サーバ側の 0 バイト検証と同じ文言にそろえる（#1842）。
export const EMPTY_RECORDING_MESSAGE =
  "音声を録音できませんでした。マイクの設定を確認して、もう一度録音してください。";

// 録音中の異常（MediaRecorder の onerror）を、発生環境（端末・ブラウザ）を追えるように報告する。
// onerror の後はブラウザが onstop を呼ぶため、送信の抑止は onstop の空判定に任せる。
export function reportRecorderError(error: unknown): void {
  void reportError({
    error: error instanceof Error ? error : new Error("MediaRecorder error"),
    source: "audio_recording_failed",
  });
}

// チャンクが 1 つも届かず 0 バイトの Blob になったことを、経過秒数と形式つきで報告する。
export function reportEmptyRecording(params: {
  elapsedSeconds: number;
  mimeType: string;
}): void {
  void reportError({
    error: new Error(
      `empty recording blob elapsed=${params.elapsedSeconds}s mimeType=${params.mimeType}`,
    ),
    source: "audio_recording_failed",
  });
}
